module.exports = __webpack_public_path__ + "static/f2c-how-2532bda90c21dfd230fdbd14cd918d66.jpg";